import {
    SET_IS_ERROR_LEAD_DISPOSITION,
    SET_IS_LOADING_LEAD_DISPOSITION,
    SET_IS_SUCCESS_LEAD_DISPOSITION,
} from '../constants/get_lead_disposition.constants';

const initialState = {
    isLoading: false,
    dispositions: [],
    error: null,
};

export const leadDisposition = (state = initialState, action) => {
    switch (action.type) {
    case SET_IS_LOADING_LEAD_DISPOSITION:
        return {
            ...state,
            isLoading: action.isLoading,
        };
    case SET_IS_SUCCESS_LEAD_DISPOSITION:
        return {
            ...state,
            dispositions: action.payload,
        };
    case SET_IS_ERROR_LEAD_DISPOSITION:
        return {
            ...state,
            error: action.error,
        };
    default:
        return state;
    }
};


// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/reducers/lead_disposition.reducer.js